import { useEffect } from 'react';
import { STORE } from './storeConfig';

export const formatInr = (value) => `₹${Number(value || 0).toLocaleString('en-IN')}`;

/** A bag line's photo: its colour's own photo when the product has one (a navy line shows the
 *  navy shirt), else the product thumbnail. Line from bag.resolveLines. */
export function lineImage(line) {
  const p = line.product;
  if (!p) return null;
  const own = line.variant?.imageUrl ? line.variant
    : line.color ? p.variants?.find(v => v.color === line.color && v.imageUrl) : null;
  if (own) return { src: own.imageUrl, srcSet: own.imageSrcset };
  return p.thumbnailUrl ? { src: p.thumbnailUrl, srcSet: p.thumbnailSrcset } : null;
}

export const variantText = ({ color, size, label } = {}) =>
  [color, size || label].filter(Boolean).join(' / ');

/** "Product name | eYantra" in the tab — "eYantra" alone on pages with no title of their own. */
export function useDocumentTitle(title) {
  useEffect(() => {
    if (title === undefined) return;
    document.title = title ? `${title} | ${STORE.displayName}` : `${STORE.displayName} — ${STORE.tagline}`;
  }, [title]);
}

/** Price shown to a shopper: the selling price, plus MRP and % off when discounted. */
export function retailPrice(product) {
  const price = Math.ceil(Number(product.marketOperatingPriceWithGst ?? product.mrp) || 0);
  const mrp = product.mrp != null ? Math.ceil(Number(product.mrp)) : null;
  const hasDiscount = mrp != null && mrp > price;
  return { price, mrp, hasDiscount, discountPercent: hasDiscount ? Math.round(((mrp - price) / mrp) * 100) : 0 };
}

/** Listing link for one brand. */
export const brandLink = (brand) => `/catalog?brand=${encodeURIComponent(brand)}`;

/** Listing link for a category, optionally narrowed to one of its types. */
export const categoryLink = (category, subcategory) =>
  `/catalog?category=${encodeURIComponent(category)}${subcategory ? `&subcategory=${encodeURIComponent(subcategory)}` : ''}`;

/** "New" tag: among the newest additions in this list (highest ids), capped at 15% of it. */
export function newestIds(products, max = 16) {
  const count = Math.min(max, Math.ceil(products.length * 0.15));
  return new Set([...products].filter(p => p.itemsAvailable !== 0).sort((a, b) => b.id - a.id).slice(0, count).map(p => p.id));
}
